<div class="content-container" [style.background-color]="color">
  <h2>{{title}}</h2>
  <p>{{text}}</p>
<!--  <a class="circle" [routerLink]="route"><span class="right-arrow"></span></a>-->
  <a class="circle-two" [routerLink]="route"><img src="assets/img/next.png" alt="next"></a>
  <!--  <a class="circle" [href]="route"><div class="right-arrow"></div></a>-->
</div>
